import { Close, ExclamationCircle } from 'flowbite-react-icons/outline'

export interface CancelOrderConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  /** Runs the cancel request after the user confirms. */
  onConfirm: () => void | Promise<void>
  isSubmitting?: boolean
}

export function CancelOrderConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  isSubmitting = false,
}: CancelOrderConfirmModalProps) {
  if (!isOpen) {
    return null
  }

  return (
    <div className="fixed inset-0 z-60 flex items-center justify-center px-4 py-6">
      <button
        type="button"
        aria-label="Close dialog"
        onClick={() => {
          if (!isSubmitting) onClose()
        }}
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
      />
      <div
        className="relative w-full max-w-md rounded-base border border-border-base bg-white p-6 shadow-lg dark:border-gray-700 dark:bg-gray-900"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cancel-order-title"
      >
        <button
          type="button"
          onClick={onClose}
          disabled={isSubmitting}
          aria-label="Close"
          className="absolute right-3 top-3 flex size-9 items-center justify-center rounded-full text-text-body transition-colors hover:bg-background-gray hover:text-text-heading disabled:cursor-not-allowed disabled:opacity-50 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
        >
          <Close className="h-5 w-5" />
        </button>

        <div className="flex flex-col items-center gap-4 pt-1">
          <div className="flex size-12 shrink-0 items-center justify-center text-error-600 dark:text-error-400" aria-hidden="true">
            <ExclamationCircle className="h-10 w-10" />
          </div>

          <div className="w-full max-w-84 text-center text-text-body dark:text-gray-400">
            <p id="cancel-order-title" className="text-lg font-semibold tracking-tight text-text-heading dark:text-white">
              Are you sure you want to cancel this order?
            </p>
          </div>

          <div className="mt-2 flex w-full flex-col-reverse gap-3 sm:flex-row sm:justify-center">
            <button
              type="button"
              onClick={onClose}
              disabled={isSubmitting}
              className="inline-flex min-h-10 flex-1 items-center justify-center rounded-full border border-border-base bg-white px-4 py-2.5 text-sm font-medium text-text-body shadow-xs transition-colors hover:bg-background-gray disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 sm:flex-initial sm:min-w-40"
            >
              No, continue order
            </button>
            <button
              type="button"
              onClick={() => void onConfirm()}
              disabled={isSubmitting}
              className="inline-flex min-h-10 flex-1 items-center justify-center rounded-full border border-transparent bg-error-600 px-4 py-2.5 text-sm font-medium text-white shadow-xs transition-colors hover:bg-error-700 disabled:cursor-not-allowed disabled:opacity-50 dark:bg-error-600 dark:hover:bg-error-700 sm:flex-initial sm:min-w-40"
            >
              {isSubmitting ? 'Canceling…' : 'Yes, cancel order'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
